// extracted by mini-css-extract-plugin
export default {"relogioNumero":"relogio_relogioNumero__d6Lgw","relogioDivisao":"relogio_relogioDivisao__7ja0t"};